<template lang="pug">
.conversation-row(:class="{ 'row-selected': isRowSelected }", :selected="$route.params.conversation_id === _id")
  b-form-row.align-items-start.flex-nowrap.mb-1
    b-col(cols="auto")
      b-form-checkbox(size="sm", :checked="isRowSelected", @change="checkboxChanged", :id="_id")
    b-col
      span.text-truncate.text-help.text-sm(v-if="account_model") {{ account_model }}
    b-col(cols="auto")
      b-badge.fe-pulse(variant="primary", v-show="!read") Nuevo mensaje
    b-col(cols="auto")
      b-badge(variant="soft-danger", v-show="!bot_enabled") Bot desactivado
    b-col(cols="auto")
      b-badge(variant="info", v-show="outbound") Outbound
  b-form-row.align-items-center.flex-nowrap.pointer(@click="openConversation")
    b-col(cols="auto")
      Avatar(:platform="platform", size="xs", :src="user.profile_pic")
    b-col.d-flex.flex-column
      .d-flex.justify-content-between.align-items-center.text-sm
        .text-truncate(v-if="userName") {{ userName }}
        .text-secondary(v-if="is_whatsapp && user.external_id") {{user.external_id.slice(-10)}}
      .d-flex.justify-content-between.align-items-center
        .text-truncate.text-secondary.mr-1(style="width: -webkit-fill-available;") {{ lastMessage.trim() || '' }}
        .text-secondary.text-nowrap {{ last_message_time ? getLastDate : parsedTimeShort }}
      .d-flex.justify-content-end.align-items-center(v-if="searchIsEnabled")
        .text-secondary-text-nowrap.text-secondary {{getMessageTime}}
  .d-flex.align-items-center.justify-content-between
    .d-flex.align-items-center.mt-2.overflow-x.scrollable-area
      b-badge.mb-1(variant="light") {{ boxName }}
      span.mx-1.mb-1(v-if="parsedLabelIds.length") |
      b-badge.mr-1.mb-1.opacity-50(v-for="(label, index) in parsedLabelIds", :key="index", :style="{'background-color': label.color, color: BWTextColor(label.color)}") {{ label.name }}
    .d-flex.align-items-center.text-secondary(v-if="parsedAdminIds.length")
      users-icon.icon-sm.mr-1(v-if="parsedAdminIds.length > 1")
      user-icon.icon-sm.mr-1(v-else)
      span.text-truncate.text-sm {{ parsedAdminIds.map(a => a.email).join(', ') }}
</template>

<script>
import Avatar from './Avatar.vue'
import boxes from '../data/boxes'
import { BWTextColor } from '../helpers/contrast-color-generator'
import { createNamespacedHelpers } from 'vuex'
import { EventBus } from '../helpers/eventBus'

const accountController = createNamespacedHelpers('account')
const labelController = createNamespacedHelpers('label')
const filtersController = createNamespacedHelpers('inbox_filters')
const conversationController = createNamespacedHelpers('conversation')

export default {
  data() {
    return {
      boxes,
    }
  },
  model: {
    prop: 'checked',
    event: 'input'
  },
  props: {
    platform: {
      type: String,
      default: ''
    },
    user: {
      type: Object,
      default: function () {
        return {}
      }
    },
    last_message_preview: {
      type: String,
      default: ''
    },
    last_message_time: {
      type: String,
      default: ''
    },
    bot_enabled: {
      type: Boolean,
      default: true
    },
    outbound: {
      type: Boolean,
      default: false
    },
    _id: {
      type: String,
      default: undefined
    },
    checked: {
      type: null
    },
    read: {
      type: Boolean,
      default: true
    },
    box: {
      type: String,
      default: 'general'
    },
    admin_ids: {
      type: Array,
      default: function () {
        return []
      }
    },
    label_ids: {
      type: Array,
      default: function () {
        return []
      }
    },
    platform_model: {
      type: Object,
      default: () => {
        return {}
      }
    },
    timezone: {
      type: String,
      default: 'America/Mexico_City'
    },
    message_id: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...filtersController.mapGetters(['searchIsEnabled']),
    ...labelController.mapState({
      labels: (state) => state.labels
    }),
    ...accountController.mapState({
      admins: (state) => state.admins
    }),
    isRowSelected() {
      return Array.isArray(this.checked)
        ? !!this.checked.filter((r) => r._id === this._id).length
        : this.checked
    },
    userName() {
      if (this.user.first_name || this.user.last_name) {
        return `${this.user.first_name || ''} ${
          this.user.last_name || ''
        }`.trim()
      } else if (!this.is_whatsapp) {
        return this.user.external_id ? this.user.external_id.slice(-10) : ''
      }
    },
    lastMessage() {
      return typeof this.last_message_preview === 'string'
        ? this.last_message_preview
        : ''
    },
    getLastDate() {
      if (!this.timezone) return
      if(!this.last_message_time) return ""
      const normal = 'DD MMM hh:mm A'
      const search = 'DD MMM YY'
      const format = this.searchIsEnabled ? search : normal
      return this.$moment(this.last_message_time)
        .tz(this.timezone)
        .format(format)
    },
    getMessageTime() {
      if (!this.timezone) return
      if(!this.last_message_time) return ""
      const format = 'hh:mm A'
      return this.$moment(this.last_message_time)
        .tz(this.timezone)
        .format(format)
    },
    momentTime() {
      const time = this.$moment(this.last_message_time)

      return time.isValid() ? time : this.$moment()
    },
    parsedTimeShort() {
      const time = {
        s: this.$moment().diff(this.momentTime, 'seconds'),
        m: this.$moment().diff(this.momentTime, 'minutes'),
        h: this.$moment().diff(this.momentTime, 'hours'),
        d: this.$moment().diff(this.momentTime, 'days'),
        mes: this.$moment().diff(this.momentTime, 'months'),
        año: this.$moment().diff(this.momentTime, 'years')
      }
      const priority = ['año', 'mes', 'd', 'h', 'm', 's']

      for (let i = 0; i < priority.length; i++) {
        if (time[priority[i]] > 0) {
          if (priority[i] == 'h' || priority[i] == 'm' || priority[i] == 's') {
            return this.momentTime.tz(this.timezone).format('DD MMM hh:mm A')
          } else {
            return `${time[priority[i]]}${priority[i]}`
          }
        }
      }

      return ''
    },
    boxName() {
      const box = this.boxes.find((b) => b.value == this.box)
      if (box) {
        return box.text
      } else {
        try {
          return this.box.charAt(0).toUpperCase() + this.box.slice(1)
        } catch (e) {
          console.log(e.message)
          return this.box
        }
      }
    },
    parsedLabelIds() {
      const labels = []

      try {
        for (const id of this.label_ids) {
          const label = this.labels.find((l) => l.label_id == id)

          if (label) labels.push(label)
        }
      } catch (e) {
        console.log(e.message)
      }

      return labels
    },
    parsedAdminIds() {
      const admins = []

      try {
        for (const id of this.admin_ids) {
          const admin = this.admins.find((l) => l.admin_id == id)
          if (admin) {
            admins.push(admin)
          }
        }
      } catch (e) {
        console.log(e.message)
      }

      return admins
    },
    account_model() {
      if (!this.platform_model) return null
      if (
        this.platform_model.phone_number &&
        this.platform_model.phone_number.length >= 5
      ) {
        return this.platform_model.phone_number
      }
      return this.platform_model.name || null
    },
    is_whatsapp() {
      return this.platform.includes('whatsapp')
    }
  },
  methods: {
    ...conversationController.mapMutations(['selectMessage']),
    checkboxChanged() {
      const index = this.checked.findIndex((r) => r._id === this._id)
      if (index >= 0) {
        this.checked.splice(index, 1)
      } else {
        this.checked.push({ _id: this._id, platform: this.platform })
      }
    },
    openConversation() {
      const { searchIsEnabled } = this
      const sameConversation = this.$route.params.conversation_id === this._id
      if (sameConversation && !searchIsEnabled) {
        return
      }
      if (searchIsEnabled) {
        this.selectMessage(this.message_id)
        if (sameConversation) EventBus.$emit('search:getConversation')
      }
      const data = {
        name: 'Conversation',
        params: { conversation_id: this._id }
      }
      this.$router.push(data).catch(() => {})
    },
    BWTextColor
  },
  mounted() {
    EventBus.$on('isCalling', (value) => { this.isCalling = value })
  },
  components: { Avatar }
}
</script>

<style lang="scss" scoped>
.conversation-row {
  width: 100%;
  padding: 0.75rem 1.25rem;
  transition: 0.5s;
  border-right: 2px solid transparent;

  &:not(:first-child) {
    border-top: 1px solid #edf2f9;
  }

  &[selected] {
    border-right: 2px solid #0e5ccf;
  }
}

.row-selected {
  background-color: rgba(14, 92, 207, 0.1);
}
</style>
